import styled from 'styled-components'

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`

export default Row;
